import React,{ useState } from 'react'
// mui
import { 
    Typography,
    Box,
    Stack,
} from "@mui/material";
// carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// components
import Title from './Title'
import Paragraph from './Paragraph'


const Gallery = () => {
    
    const [currentIndex, setCurrentIndex] = useState();

    const imageData = [
        {
            alt: 'image1',
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1688670845/user-uploads/qtpbmpb7nedcrjv1gs0a.png'
        },
        {
            alt: 'image2',
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1688484213/icons/team-egress-window-avatar_rwmhgr.png'
        },
        {
            alt: "image3",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1681496795/jackson-egress-windows-bring-light-and-life-to-basements-enhanced-transformed_yhmico.png'
        },
        {
            alt: "image4",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1681214896/egress-windows/basement-egress-area-wall-window-well-fiberglass-stone_8_hadsvw.png'
        },
        
        {
            alt: "image5",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1680906029/egress-windows/escape-egress-window_gv4rbo_aetm8u.png'
        },
        {
            alt: "image5",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1689194754/egress-window-gallery/rs_w_984_h_738_xkptqr.png'
        },        
        {
            alt: "image6",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1689194781/egress-window-gallery/rs_w_984_h_984_vkjjyd.png'
        },        
        {
            alt: "image7",
            url: 'https://res.cloudinary.com/dpy1up1n6/image/upload/v1689194771/egress-window-gallery/rs_w_1280_h_960_1_kp63br.png'
        }
    ];
  
    const renderSlides = imageData.map((image) => (
    <div key={image.alt}>
        <img src={image.url} alt={image.alt} />
    </div>
    ));


    const handleChange = (index) => {
        setCurrentIndex(index);
    }

    return (
        <Stack
        direction='column'
        justifyContent= 'center'
        alignItems= 'center'
        width= '100vw'
        position='relative'
        
        
        paddingTop='50px'
        sx={{
            py: '50px',
            px: 5,
            display: { xs: 'flex'},
            width: '100vw'
        }}
        >
            <Box
            component='section'
            sx={{
                paddingBottom: 3,
                width: '100vw'
            }}
            >
                <Title 
                text={
                    'Spreading Light And Life'
                }
                textAlign={'center'}
                />
                <Typography
                variant='h5'
                component='h5'
                align='center'
                sx={{
                    paddingTop: 1,
                    width:'90%'                }}
                >
                    Egress Window Installations
                </Typography>
                <Paragraph text={
                    'Browse our project gallery.'
                } 
                maxWidth = {'90%'}
                mx={'auto'}
                textAlign={'center'}
                width={'90%'}
                sx={{width:'90%', maxWidth:'90vw'}}
                />
            </Box>
            
            <Box sx={{ 
                maxwidth: '100%',
                width: '100vw',
                '@media (min-width:1000px)': {
                    width: '50%'
                  }
            }}>
                <Carousel
                showStatus={false}
                centerSlidePercentage={80}
                showThumbs={false}
                dynamicHeight={false}
                centerMode={true}
                showArrows={true}
                autoPlay={true}
                infiniteLoop={true}
                swipeable={true}
                selectedItem={imageData[currentIndex]}
                emulateTouch={true}
                onChange={handleChange}
                className="carousel-container"
                >
                {renderSlides}
                </Carousel>
            </Box>
        </Stack>
    )
}

export default Gallery